import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import {
  CloudUpload,
  X,
} from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
} from "../../../../../component/form/form-layout";
import LeftSidePopupLayout from "../../../../../component/popup/modal-layout";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import { Alert, Snackbar } from "@mui/material";
import XCloseIcon from "../../../../../component/icons/x-close";

const UpdateSubTask = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  usersList = [],
  taskData = {},
}) => {
  const apiCall = useApiCall();

  const [pendingUploadsSubTask, setPendingUploadsSubTask] = useState([]);
  const [isDraggingSubTask, setIsDraggingSubTask] = useState(false);

  const [alertData, setAlertData] = useState({ isShow: false });

  useEffect(() => {
    console.log("Task Data", taskData);
    if (taskData?.sub_task_id) {
      subTaskFormik.setFieldValue("sub_task_name", taskData?.sub_task_name);
      subTaskFormik.setFieldValue("priority", taskData?.priority);
      subTaskFormik.setFieldValue("sub_task_status", taskData?.sub_task_status);
      subTaskFormik.setFieldValue("deadline", taskData?.deadline);
      subTaskFormik.setFieldValue(
        "assignee",
        taskData?.assigned_users.map((user) => user.user_id)
      );
      subTaskFormik.setFieldValue(
        "sub_task_description",
        taskData?.sub_task_description
      );

      setPendingUploadsSubTask(taskData?.attachments);
    }
  }, []);

  const assignedData = [
    {
      name: "ALex",
      id: 1,
    },
    {
      name: "Jhon",
      id: 2,
    },
    {
      name: "ERobot",
      id: 3,
    },
    {
      name: "Mart",
      id: 4,
    },
    {
      name: "Liza",
      id: 5,
    },
  ];

  const priority = [
    {
      name: "Low",
      value: "low",
    },
    {
      name: "Medium",
      value: "medium",
    },
    {
      name: "High",
      value: "high",
    },
  ];

  const tStatus = [
    { name: "Pending", value: "pending" },
    { name: "In Process", value: "in_process" },
    { name: "Completed", value: "completed" },
    { name: "Cancelled", value: "cancelled" },
    // { name: "Incomplete Details", value: "incomplete_details" },
    // { name: "QA", value: "qa" },
    // { name: "QA Design", value: "qa_design" },
    // { name: "Delivered To Sales", value: "delivered_to_sales" },
    // { name: "File Sent To Client", value: "file_sent_to_client" },
    // { name: "Revision", value: "revision" },
    // { name: "Design", value: "design" },
    // { name: "Linked-In", value: "linked_in" },
    // { name: "Job Posting", value: "job_posting" },
    // { name: "On-Hold", value: "on_hold" },
    // { name: "Unassigned", value: "unassigned" },
    // { name: "Editing / Formatting", value: "editing_formatting" },
    // { name: "Client Approval", value: "client_approval" },
    // { name: "In-Active", value: "in_active" },
    // { name: "Final Drafts", value: "final_drafts" },
  ];
  const statusOptions = tStatus?.map((tm) => ({
    value: tm?.value,
    label: tm?.name,
  }));

  const userOptions = usersList?.map((s) => ({
    value: s.userid,
    label: s.name,
  }));

  const assignedOptions = assignedData?.map((tm) => ({
    value: tm?.id,
    label: tm?.name,
  }));
  const priorityOptions = priority?.map((tm) => ({
    value: tm?.value,
    label: tm?.name,
  }));

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const subTaskValidation = yup.object({
    sub_task_name: yup.string().required("This Field is Required"),
    priority: yup.string().required("This Field is Required"),
    deadline: yup.string().required("This Field is Required"),
    assignee: yup
      .array()
      .min(1, "This Field is Required")
      .required("This Field is Required"),
  });

  const subTaskFormik = useFormik({
    initialValues: {
      sub_task_name: "",
      priority: "",
      deadline: "",
      sub_task_status: "",
      source: [],
      sub_task_description: "",
      media: "",
      is_qa: 1,
      source: "logo",
    },
    validationSchema: subTaskValidation,
    onSubmit: async (values) => {
      const ids = pendingUploadsSubTask?.map((item) => item.id) || [];

      let data = {
        project_key: taskData?.projectKey,
        task_key: taskData?.task_key,
        sub_task_name: values.sub_task_name,
        sub_task_description: values?.sub_task_description,
        sub_task_status: values?.sub_task_status,
        is_qa: values?.is_qa,
        deadline: values?.deadline,
        priority: values?.priority,
        source: values?.source,
        is_tagged: "",
        assigned_users: values.assignee,
        attachment_ids: ids,
      };

      try {
        const res = await apiCall({
          method: "post",
          url: `subtasks/update-subtask/${taskData?.sub_task_id}`,
          data,
        });
        console.log("API response:", res);
        onSubmit(res?.message || `Request Submitted`);
        onClose();
        subTaskFormik.resetForm();
        setPendingUploadsSubTask([]);
      } catch (error) {
        console.log(error);
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Some Thing Went Wrong"
        );
      }
    },
  });

  /// SUb task Attactments Uploads

  const handleSubTaskFileChange = async (e) => {
    const newFiles = Array.from(e.target.files);
    if (!newFiles.length) return;

    const formData = new FormData();
    newFiles.forEach((f) => formData.append("files[]", f));

    try {
      const uploadRes = await apiCall({
        method: "post",
        url: "attachments/upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadRes?.data?.length) {
        setPendingUploadsSubTask((prev) => [...uploadRes.data, ...prev]);
      }
    } catch (err) {
      console.error("Upload error:", err);
    } finally {
      e.target.value = ""; // reset file input
    }
  };

  // Handle drag & drop upload
  const handleSubTaskDragOver = (e) => {
    e.preventDefault();
    setIsDraggingSubTask(true);
  };
  const handleSubTaskDragLeave = (e) => {
    e.preventDefault();
    setIsDraggingSubTask(false);
  };
  const handleSubTaskDrop = async (e) => {
    e.preventDefault();
    setIsDraggingSubTask(false);

    const droppedFiles = Array.from(e.dataTransfer.files);
    if (!droppedFiles.length) return;

    const formData = new FormData();
    droppedFiles.forEach((f) => formData.append("files[]", f));

    try {
      const uploadRes = await apiCall({
        method: "post",
        url: "attachments/upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadRes?.data?.length) {
        setPendingUploadsSubTask((prev) => [...uploadRes.data, ...prev]);
      }
    } catch (err) {
      console.error("Upload error:", err);
    }
  };

  // Delete pending unconfirmed upload
  const removePendingUploadSubTask = async (id) => {
    try {
      await apiCall({
        method: "post",
        url: taskData?.sub_task_id
          ? `attachments/delete/${id}`
          : `attachments/delete-unconfirmed-attachment/${id}`,
      });
      setPendingUploadsSubTask((prev) => prev.filter((p) => p.id !== id));
    } catch (err) {
      console.error("Failed to delete unconfirmed file:", err);
    }
  };

  return (
    <>
      <LeftSidePopupLayout
        popupStatus={true}
        className={Style.departmentChangeModal}
      >
        <div
          className={`${Style.modal_header} ${Style.addMeModal_head} flex justify-between items-center`}
        >
          <h4>Update Sub Task </h4>
          <div
            onClick={onClose}
            className={`${Style.close_btn} cursor-pointer`}
          >
            <XCloseIcon />
          </div>
        </div>
        <div style={{ height: "100%", overflow: "auto" }}>
          <form
            onSubmit={subTaskFormik.handleSubmit}
            className={Style.modal_main}
          >
            <div className={Style.modal_body}>
              <FormArea>
                {/* Name */}
                <FeildWraper width="100%">
                  <FormLabel required>Name</FormLabel>
                  <input
                    type="text"
                    name="sub_task_name"
                    value={subTaskFormik.values.sub_task_name}
                    onChange={subTaskFormik.handleChange}
                    placeholder="name"
                  />
                  {subTaskFormik.touched.sub_task_name &&
                    subTaskFormik.errors.sub_task_name && (
                      <FeildError>
                        {subTaskFormik.errors.sub_task_name}
                      </FeildError>
                    )}
                </FeildWraper>

                <FeildWraper>
                  <FormLabel required>Assigned</FormLabel>

                  <Select
                    name="assignee"
                    className="text-sm"
                    classNamePrefix="react-select"
                    options={userOptions}
                    isMulti
                    components={{
                      IndicatorSeparator: () => null,
                      LoadingIndicator: () => null,
                    }}
                    value={userOptions?.filter((option) =>
                      Array.isArray(subTaskFormik.values.assignee)
                        ? subTaskFormik.values.assignee.includes(option.value)
                        : false
                    )}
                    filterOption={(option, inputValue) =>
                      option.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                    onChange={(selectedOptions) => {
                      const ids = selectedOptions?.map((opt) => opt.value);
                      subTaskFormik.setFieldValue("assignee", ids);
                    }}
                    placeholder="Search or select..."
                    isClearable
                    menuPlacement="auto"
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "35px",
                        height: "auto",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                        boxShadow: state.isFocused ? "none" : "none",
                        "&:hover": { borderColor: "#DFDFDF" },
                        fontSize: "13px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        padding: "0 14px",
                        cursor: state.isDisabled ? "not-allowed" : "normal",
                        margin: 0,
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "auto",
                        padding: 0,
                        margin: 0,
                        flexWrap: "wrap",
                        gap: "2px",
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor: "#E5E7EB",
                        borderRadius: "3px",
                        padding: "2px 6px",
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        height: "auto",
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: "#666",
                        ":hover": {
                          backgroundColor: "#D1D5DB",
                          color: "#000",
                        },
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: state.isSelected ? "#FFF" : "#1E1E1E",
                        backgroundColor: state.isSelected
                          ? "#3b82f6"
                          : state.isFocused
                          ? "#F3F4F6"
                          : "#FFF",
                        padding: "8px 14px",
                        cursor: "pointer",
                      }),
                    }}
                  />
                  {subTaskFormik.touched.assignee &&
                    subTaskFormik.errors.assignee && (
                      <FeildError>{subTaskFormik.errors.assignee}</FeildError>
                    )}
                </FeildWraper>

                {/* Priority */}
                <FeildWraper>
                  <FormLabel required>Priority</FormLabel>
                  <Select
                    name="priority"
                    className="text-sm"
                    classNamePrefix="react-select"
                    options={priorityOptions}
                    components={{
                      IndicatorSeparator: () => null,
                      LoadingIndicator: () => null,
                    }}
                    value={priorityOptions?.find(
                      (option) => option.value === subTaskFormik.values.priority
                    )}
                    onChange={(selectedOption) => {
                      subTaskFormik.setFieldValue(
                        "priority",
                        selectedOption?.value || ""
                      );
                    }}
                    filterOption={(option, inputValue) =>
                      option.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                    placeholder="Search or select..."
                    isClearable
                    menuPlacement="auto"
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "35px",
                        height: "auto",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                        boxShadow: state.isFocused ? "none" : "none",
                        "&:hover": { borderColor: "#DFDFDF" },
                        fontSize: "13px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        padding: "0 14px",
                        cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "auto",
                        padding: "0 0px 0",
                      }),
                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        height: "auto",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#717680",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 99999,
                      }),
                      menu: (base) => ({
                        ...base,
                        marginTop: "2px",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: state.isSelected ? "#FFF" : "#1E1E1E",
                        backgroundColor: state.isSelected
                          ? "#3b82f6"
                          : state.isFocused
                          ? "#F3F4F6"
                          : "#FFF",
                        padding: "8px 14px",
                        cursor: "pointer",
                      }),
                      indicatorContainer: (base) => ({
                        ...base,
                        padding: 0,
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        padding: 0,
                      }),
                    }}
                  />
                  {subTaskFormik.touched.priority &&
                    subTaskFormik.errors.priority && (
                      <FeildError>{subTaskFormik.errors.priority}</FeildError>
                    )}
                </FeildWraper>

                {/* Status */}
                <FeildWraper>
                  <FormLabel required>Status</FormLabel>
                  <Select
                    name="sub_task_status"
                    className="text-sm"
                    classNamePrefix="react-select"
                    options={statusOptions}
                    components={{
                      IndicatorSeparator: () => null,
                      LoadingIndicator: () => null,
                    }}
                    value={statusOptions?.find(
                      (option) =>
                        option.value === subTaskFormik.values.sub_task_status
                    )}
                    onChange={(selectedOption) => {
                      subTaskFormik.setFieldValue(
                        "sub_task_status",
                        selectedOption?.value || ""
                      );
                    }}
                    filterOption={(option, inputValue) =>
                      option.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                    placeholder="Search or select Status..."
                    isClearable
                    menuPlacement="auto"
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "35px",
                        height: "auto",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                        boxShadow: state.isFocused ? "none" : "none",
                        "&:hover": { borderColor: "#DFDFDF" },
                        fontSize: "13px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        padding: "0 14px",
                        cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "auto",
                        padding: "0 0px 0",
                      }),
                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        height: "auto",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#717680",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 99999,
                      }),
                      menu: (base) => ({
                        ...base,
                        marginTop: "2px",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: state.isSelected ? "#FFF" : "#1E1E1E",
                        backgroundColor: state.isSelected
                          ? "#3b82f6"
                          : state.isFocused
                          ? "#F3F4F6"
                          : "#FFF",
                        padding: "8px 14px",
                        cursor: "pointer",
                      }),
                      indicatorContainer: (base) => ({
                        ...base,
                        padding: 0,
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        padding: 0,
                      }),
                    }}
                  />
                  {subTaskFormik.touched.sub_task_status &&
                    subTaskFormik.errors.sub_task_status && (
                      <FeildError>
                        {subTaskFormik.errors.sub_task_status}
                      </FeildError>
                    )}
                </FeildWraper>

                {/* Deadline */}

                <FeildWraper>
                  <FormLabel required>Deadline</FormLabel>
                  <input
                    type="date"
                    name="deadline"
                    value={subTaskFormik.values.deadline}
                    onChange={subTaskFormik.handleChange}
                  />
                  {subTaskFormik.touched.deadline &&
                    subTaskFormik.errors.deadline && (
                      <FeildError>{subTaskFormik.errors.deadline}</FeildError>
                    )}
                </FeildWraper>

                {/* Description */}
                <FeildWraper width="100%">
                  <FormLabel>Description</FormLabel>
                  <textarea
                    name="sub_task_description"
                    value={subTaskFormik.values.sub_task_description}
                    onChange={subTaskFormik.handleChange}
                    rows={6}
                    placeholder="Write  description here..."
                  />
                </FeildWraper>

                <FeildWraper width="100%">
                  {/* Upload Box */}
                  <div
                    onClick={() => document.getElementById("fileInput").click()}
                    onDragOver={handleSubTaskDragOver}
                    onDragLeave={handleSubTaskDragLeave}
                    onDrop={handleSubTaskDrop}
                    className={`border-2 border-dashed rounded-xl p-6 flex flex-col items-center justify-center text-center transition cursor-pointer ${
                      isDraggingSubTask
                        ? "border-black bg-gray-100"
                        : "border-gray-300 bg-gray-50 hover:bg-gray-100"
                    }`}
                  >
                    <CloudUpload className="w-10 h-10 text-black mb-3" />
                    <p className="text-gray-700 text-sm mb-2">
                      Drag & drop files here or click to select
                    </p>

                    <input
                      type="file"
                      multiple
                      onChange={handleSubTaskFileChange}
                      className="hidden"
                      id="fileInput"
                    />

                    {/* Pending uploads */}
                    {pendingUploadsSubTask?.length > 0 && (
                      <div className="mt-4 w-full max-w-sm">
                        <div className="text-xs text-gray-700 mb-2 font-semibold">
                          Pending uploads
                        </div>
                        <ul className="text-xs text-gray-700 text-left space-y-2">
                          {pendingUploadsSubTask?.map((p) => (
                            <li
                              key={p.id}
                              className="flex items-center justify-between bg-gray-100 px-3 py-2 rounded-md"
                            >
                              <span className="truncate max-w-[150px]">
                                {p.file_name}
                              </span>
                              <button
                                type="button"
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  await removePendingUploadSubTask(p.id);
                                }}
                                className="text-gray-500 hover:text-red-600 transition"
                                title="Remove pending upload"
                              >
                                <X className="w-4 h-4" />
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </FeildWraper>
              </FormArea>
            </div>

            <div className={Style.modal_foot}>
              <button
                type="submit"
                className={Style.dcmb__submit}
              >
                Update Sub Task
              </button>
            </div>
          </form>
        </div>
      </LeftSidePopupLayout>

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UpdateSubTask;
